<template>
    <div id="table-layout">
        <div id="tableWrapperContainer" style="overflow-y: auto; overflow-x: hidden; max-height: -webkit-fill-available;">
            <dyn-table-wrapper v-if="show" :arrayToTable="arrayToTable" :focus="focus" name="WrapperGrid"></dyn-table-wrapper>
        </div> 
    </div>
</template> 

<script>
import DynTableWrapper from "../dynamic/DynTableWrapper.vue";

import { eventBus } from "../../eventbus";

export default {
  props: {
    activeData: Object,
    focus: String
  },
  components: {
    DynTableWrapper
  },
  created: function(){
    var vm = this;
    eventBus.$on("heightMutation", function(){
      vm.show = false;
      vm.setTableHeight();
      vm.$nextTick(function(){
        vm.show = true;
      })
    })
  },
  mounted: function() {
    this.setTableHeight();
    

    if (this.activeData) {
      this.assignData();
    }
  },
  beforeDestroy: function(){
    this.$store.commit("setLastHeight", this.table_height_state);
  },
  data: function() {
    return {
      show: true,
      arrayToTable: [],
      table_height_state: null
    };
  },
  watch: {
    activeData: function() {
      this.assignData();
    }
  },
  methods: {
    setTableHeight: function(){
      this.table_height_state = this.$store.getters.getLastHeight;
      var h = this.$root.WINDOW_HEIGHT - 60;
      this.$store.commit("setLastHeight", h);
    },
    assignData: function() {
      var vm = this;
      this.arrayToTable = this.activeData.children.filter(function(obj){
        if(vm.$Behaviors.viewLinksInList){ //se voglio vedere i link nella lista
          return obj //mostro tutti, anche quelli con la proprietà link
        }else{
          return !obj.lin //mostro solo quelli che non hanno la proprietà link
        }
      });
      /* HIDDEN COLUMN NUMBER DATAFIELD Mappato, non dovrebbe essere più necessario
      this.arrayToTable = this.arrayToTable.map(function(obj){
        try {
          if(obj.sor){
            obj.sor = Number(obj.sor)
          }
        } catch(err){
          console.log(err)
        }
        return obj;
      })
      console.log(this.arrayToTable)
      */
    }
  }
};
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/sub-views/Table.vue?ba65ef78